import { Vector } from '../../shape/vector/vector';
/**
 * Connect 2 points with a single line with arrow.
 * ----->
 */
export var Link = function Link(options, context) {
  var _options$arrow = options.arrow,
    arrow = _options$arrow === void 0 ? false : _options$arrow;
  return function () {
    return Vector(Object.assign(Object.assign({}, options), {
      arrow: arrow
    }), context).apply(void 0, arguments);
  };
};
Link.props = {
  defaultMarker: 'line',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};